import BreadCrumbs from "../../common/breadcrumbs";
import SearchBox from "../../common/searchBox";
import Table from "../../common/table";
import ReactTooltip from "react-tooltip";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import Icon from "../../icons/index";
import { useStore } from "../../../zustand/store";
import qs from "qs";
import Modal from "../../common/Modal";

import { Button } from "react-bootstrap";
import CS from "../../../services/commonService";
import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
	usegetAllTransactionsHistory,
	useDownloadTransactionsHistory,
} from "../../../queryHooks/usePayouts";
import { saveAs } from "file-saver";
import CreatePayouts from "./createPayoutsModal";
import { URL } from "../../../constants/URL";
import { useGetAllRestaurants } from "../../../queryHooks";
import { modules } from "../../../constants/Modules";

const columnKey = "payoutsHistory";
//	Component starts
const PayoutsHistory = () => {
	const navigate = useNavigate();
	const lastPageData = useStore((state) => state.lastPageData);
	const setLastPageData = useStore((state) => state.setLastPageData);
	//	State values

	const [restaurants, setRestaurants] = useState([]);
	const [tableData, setTableData] = useState([]);
	const setLoading = useStore((state) => state.setLoading);
	const [open, setOpen] = useState(false);
	const [itemsPerPage, setItemsPerPage] = useState(
		lastPageData?.[modules.PAYOUTS]?.items_per_page || 10
	);
	const [pageNow, setPageNow] = useState(
		lastPageData?.[modules.PAYOUTS]?.page || 1
	);
	const [transactionsPayload, setTransactionsPayload] = useState(
		lastPageData?.[modules.PAYOUTS] || {
			pagination: true,
			items_per_page: itemsPerPage,
			page: pageNow,
			sort: { created_at: "DESC" },
		}
	);

	const paymentOptions = [
		{ value: "PENDING", label: "PENDING" },
		{ value: "SUCCESSFUL", label: "SUCCESSFUL" },
		{ value: "FAILED", label: "FAILED" },
		{ value: "CANCELLED", label: "CANCELLED" },
	];

	const closeModal = useCallback(() => setOpen(false), []);

	const {
		data: dataGetTransactions,
		isLoading,
		refetch,
	} = usegetAllTransactionsHistory(qs.stringify(transactionsPayload));

	useEffect(() => {
		if (dataGetTransactions && dataGetTransactions.status === "success") {
			let respData = dataGetTransactions.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [dataGetTransactions]);

	const {
		mutateAsync: downloadTransactionsHistory,
		data: dataDownloadTransactionsHistory,
		isLoading: isLoadingDownload,
	} = useDownloadTransactionsHistory(transactionsPayload);

	useEffect(() => {
		if (dataDownloadTransactionsHistory) {
			saveAs(
				dataDownloadTransactionsHistory.data?.filePath,
				"transactionsHistory.xlsx"
			);
		}
	}, [dataDownloadTransactionsHistory]);

	const getTransactionId = (transactions) => {
		if (transactions.length === 0) return null;
		else if (transactions.length === 1) return transactions[0]?.payment_id;
		else {
			const sortedTransactions = sortTransactionByDate(transactions);
			return sortedTransactions[0]?.payment_id;
		}
	};

	const sortTransactionByDate = (transactions) => {
		return transactions.sort((a, b) => {
			let da = new Date(a.created_at),
				db = new Date(b.created_at);
			return db - da;
		});
	};

	const { data: dataGetAllRestaurants } = useGetAllRestaurants(
		qs.stringify({
			pagination: false,
			filter: { ["admin_approval_status"]: "APPROVED" },
		})
	);

	useEffect(() => {
		if (dataGetAllRestaurants && dataGetAllRestaurants.data?.records) {
			let _restaurants = [];
			dataGetAllRestaurants.data.records.forEach((element) => {
				_restaurants.push({
					label: element.name,
					value: element.id,
				});
			});
			setRestaurants(_restaurants);
		}
	}, [dataGetAllRestaurants]);

	const columns = [
		{
			label: "Date",
			type: "date",
			sort: true,
			path: "created_at",
			alias: "created_at",
			filterDate: true,
			content: (item) => getCurrentTimezoneDate(item.created_at),
		},
		{
			label: "Restaurant",
			type: "string",
			// sort: true,
			// alias: "restaurant",
			path: "restaurant.name",
			aliasFilter: "payouts.restaurant_id",
			filterOptions: restaurants,
			content: (item) => (
				<>
					<Link
						to={{
							pathname: `${URL.restaurants}/${item.restaurant_id}`,
							state: { key: "upcomingPayouts" },
						}}
						onClick={() => {
							setLastPageData({ [modules.PAYOUTS]: transactionsPayload });
						}}
					>
						{/* <span>{CS.renderImageUrl(item.restaurantPhoto)}</span> */}
						<span className="pl-2">{item?.restaurant?.name}</span>
					</Link>
				</>
			),
		},
		{
			label: "Transaction Id",
			type: "string",
			path: "transactions.payment_id",
			content: (item) => (
				<div className="d-flex align-items-center">
					{getTransactionId(item?.transactions) == "" ? (
						"--"
					) : (
						<span>{getTransactionId(item?.transactions)}</span>
					)}
				</div>
			),
		},

		{
			label: "Amount",
			type: "string",
			sort: true,
			path: "amount",
			alias: "amount",
			content: (item) => (
				<div className="d-flex align-items-center">
					{item.amount ? "$" + item.amount : ""}
				</div>
			),
		},
		{
			label: "Status",
			type: "string",
			path: "status",
			filterOptions: paymentOptions,
			aliasFilter: "status",
			content: (item) => (
				<div className="d-flex align-items-center">
					{item.status ? item.status : ""}
				</div>
			),
		},

		// {
		// 	label: "Action",
		// 	type: "boolean",
		// 	content: (item) => (
		// 		<>
		// 			<Icon type="show" data-tip data-for="show" />
		// 			<ReactTooltip id="show" place="top" effect="solid">
		// 				Show
		// 			</ReactTooltip>
		// 		</>
		// 	),
		// },
	];

	return (
		<>
			<BreadCrumbs
				title="Payouts Management"
				data={[{ label: "Payouts History" }]}
			/>
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-4 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												search={(value) => {
													setPageNow(1);
													setTransactionsPayload({
														...transactionsPayload,
														search: {
															name: !value && value === "" ? undefined : value,
															email: !value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>

									<div className="col-sm-8">
										<div className="right-buttons d-flex justify-content-end">
											<button
												className="btn btn-default minW-md-0 btn-bg-white"
												onClick={() => {
													navigate(URL.unClaimedGiftsPayout);
												}}
											>
												Unclaimed Gifts - Transfer Funds
											</button>
											<button
												className="btn btn-default minW-md-0 btn-bg-white"
												onClick={() => {
													setOpen(true);
												}}
											>
												Create Payout
											</button>
											<button
												className="btn btn-default minW-md-0 btn-bg-white"
												onClick={() =>
													downloadTransactionsHistory({
														...transactionsPayload,
														timeZone: CS.getTimezone(),
													})
												}
											>
												{isLoadingDownload ? "Downloading..." : "Download"}
											</button>
										</div>
									</div>
								</div>
							</div>
							<Modal open={open} onCloseModal={closeModal}>
								<CreatePayouts onCloseModal={closeModal} refetch={refetch} />
							</Modal>
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								sortCol={(obj) => {
									setPageNow(1);
									setTransactionsPayload({
										...transactionsPayload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setTransactionsPayload({
										...transactionsPayload,
										page,
									});
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setTransactionsPayload({
										...transactionsPayload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(
											transactionsPayload.filter,
											obj
										);
										setPageNow(1);
										setTransactionsPayload({
											...transactionsPayload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setTransactionsPayload({
											...transactionsPayload,
											filter: {
												...transactionsPayload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setTransactionsPayload({
										...transactionsPayload,
										filter_date: dates && {
											...transactionsPayload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default PayoutsHistory;
